// @flow

export const FontSizes = {
  BASE: '1rem',
  BODY: '12px',
  HEADING: '2rem',
  H1: '2rem',
  H2: '1.5rem',
  H3: '1.167rem',
  H4: '1rem',
  H5: '0.833rem',
  H6: '0.667rem',
  P: '1rem',
  FINE_PRINT: '0.833rem',
};

export const FontWeights = {
  BASE: 400,
  LIGHT: 300,
  NORMAL: 400,
  BOLD: 700,
};

export const LineHeights = {
  BASE: '1.8',
};

export const FontFamilies = {
  DEFAULT: ['Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif']
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/common/fonts.js